import React, {useEffect} from 'react';
import RadioButton from '../../../atoms/RadioButton/RadioButton';
import Props from './typings';
import {StyledSubcategory} from './styles';
import List from '../List';

const RadioList = ({options, selected, group, style = 'text', callback}: Props) => {
  const defaultOption = 'all';
  const checkedOptions = selected.map((option) => option.value);

  const optionIsSelected = (option) => {
    if (selected.length === 0) {
      return option === defaultOption;
    } else {
      return checkedOptions.includes(option);
    }
  };

  const selectedSubcategories = (parentOption) => {
    if (!checkedOptions.includes(parentOption)) return [{value: defaultOption}];

    // Values need to be unique
    const selection = selected.filter((option) => option.value === parentOption)[0];
    if (selection.subcategories && selection.subcategories.length > 0) {
      return [...selection.subcategories];
    } else {
      return [{value: defaultOption}];
    }
  };

  const combineResponse = (subSelection, parent) => {
    if (checkedOptions.includes(parent)) {
      const selection = selected.filter((option) => option.value === parent)[0];
      selection.subcategories = subSelection;
      callback([selection]);
    }
  };

  const buttonResponse = (resp) => {
    if (resp === defaultOption) {
      callback([]);
    } else {
      callback([{value: resp}]);
    }
  };

  useEffect(() => {
    if (selected.length > 1) callback([selected[0]]);
  }, [selected]);

  return (
    <>
      {options.map((option, key) => (
        <React.Fragment key={key}>
          <RadioButton
            checked={optionIsSelected(option.value)}
            label={option.label}
            value={option.value}
            group={group}
            callback={buttonResponse}
            style={style}
          />

          {option.sublist && (
            <StyledSubcategory $visible={checkedOptions.includes(option.value)}>
              <List
                type={option.sublist.type}
                style={option.sublist.style}
                group={option.value}
                selected={selectedSubcategories(option.value)}
                options={option.sublist.options}
                callback={(resp) => combineResponse(resp, option.value)}
              />
            </StyledSubcategory>
          )}
        </React.Fragment>
      ))}
    </>
  );
};

export default RadioList;
